import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import ConfirmModal from "~/components/common/ConfirmModal";
import Button from "~/components/common/Button";
import UserLink from "~/components/user/UserLink";
import TimeAgoTag from "~/components/app/TimeAgoTag";
import { ThunderboltFilled } from "@ant-design/icons";
import { showAppModal, showAppMessage } from "~/redux/actions/app";
import { getCommentChargeList } from "~/redux/actions/comment";
import { openCommentChargeDialog } from "~/utils/commentCharge";
import styles from "./CommentChargeListModal.module.css";

const PAGE_SIZE = 50;

// 评论充电人列表弹窗（common ConfirmModal 壳，非 antd）：
// 未充电且非作者时底部按钮为「充电支持Ta」，否则仅「关闭」。
const CommentChargeListModal = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);
  const user = useSelector((state) => state.user.user);
  // hooks
  const [state, setState] = useState({
    charges: null,
    pager: null,
    charged: false,
    eleTotal: 0,
  });

  // props
  const comment = props.comment;
  const isOwner = user && comment && user.id === comment.user.id;
  const nextPage = state.pager && state.pager.next_page;
  const canCharge = !isOwner && !state.charged;

  // handles
  const handleFetch = (page, previous) => {
    // getCommentChargeList 是普通 API 函数（返回 Promise），不能经 bindActionCreators dispatch
    getCommentChargeList(token, comment.id, { page, per_page: PAGE_SIZE })
      .then((data) => {
        setState({
          charges: previous ? [...previous, ...data.charges] : data.charges,
          pager: data.pager,
          charged: data.charged,
          eleTotal: data.charges_ele,
        });
      })
      .catch(() => {
        setState({
          charges: previous || [],
          pager: null,
          charged: false,
        });
        dispatch(showAppMessage("加载失败", "error"));
      });
  };
  const handleLoadMore = () => {
    handleFetch(nextPage, state.charges);
  };
  const handleCharge = () => {
    openCommentChargeDialog({
      comment,
      user,
      token,
      showAppModal,
      router,
      onCharged: () => {
        setState((prev) => ({ ...prev, charged: true }));
      },
    });
  };

  // events
  useEffect(() => {
    if (props.isOpen && comment) {
      handleFetch(1);
    }
  }, [props.isOpen, comment && comment.id]);

  if (!comment) {
    return null;
  }

  // views
  const list = !state.charges ? (
    <div className={styles.empty}>加载中...</div>
  ) : state.charges.length === 0 ? (
    <div className={styles.empty}>还没有居民为这条评论充电</div>
  ) : (
    <>
      <div className={styles.list}>
        {state.charges.map((charge) => (
          <div
            className={styles.item}
            key={charge.user ? charge.user.id : charge.id}
          >
            <UserLink
              user={charge.user}
              showAvatar
              size={32}
              className={styles.user}
            />
            <span className={styles.ele}>
              <ThunderboltFilled className={styles.eleIcon} />
              {charge.ele}
            </span>
            <span className={styles.time}>
              <TimeAgoTag time={charge.created_at} />
            </span>
          </div>
        ))}
      </div>
      {nextPage && (
        <div className={styles.loadMore}>
          <Button
            size="sm"
            ghost
            onClick={handleLoadMore}
          >
            加载更多
          </Button>
        </div>
      )}
    </>
  );

  return (
    <ConfirmModal
      open={!!props.isOpen}
      title={
        <>
          充电列表
          {state.pager && (
            <span className={styles.stats}>
              {state.pager.total_count} 人 · {state.eleTotal} 电量
            </span>
          )}
        </>
      }
      content={list}
      okText={canCharge ? "充电支持Ta" : "关闭"}
      hideCancel={!canCharge}
      onOk={canCharge ? handleCharge : props.hideModal}
      onCancel={props.hideModal}
    />
  );
};

export default CommentChargeListModal;
